import { useCallback, useEffect, useState } from 'react'

const useMultipleCostInvoicePaymentTerm = ({ form, onChange, lines, company, calculatesDueDate }) => {
  const [selectedPaymentTerm, setSelectedPaymentTerm] = useState(null)

  const problem = useCallback(
    () => lines?.filter(
      (line) => line.paymentTerm && line.paymentTerm.days !== selectedPaymentTerm?.days
    ).length > 0,
    [lines, selectedPaymentTerm, company?.paymentTerms]
  )

  const companyPaymentTermDays = useCallback(
    () => (company && company.paymentTerms ? company.paymentTerms?.map(
      (term) => term.days
    ) : []),
    [company]
  )

  const paymentTermsOfTransactions = useCallback(
    () => lines.filter(
      line => line.paymentTerm && line.paymentTerm.days
    ).map(line => ({ id: line.transactionId, ...line.paymentTerm })),
    [lines, companyPaymentTermDays]
  )

  const onPaymentTermChange = useCallback((_, paymentTerm) => {
    if (paymentTerm) {
      let selectedPaymentTerm = null
      if (paymentTerm && paymentTerm?.includes('company_')) {
        const checkFor = paymentTerm.replace('company_', '')
        selectedPaymentTerm = company?.paymentTerms.find(item => parseInt(item.id, 10) === parseInt(checkFor, 10))
      } else {
        const checkFor = paymentTerm.replace('transaction_', '')
        selectedPaymentTerm = paymentTermsOfTransactions()?.find(item => parseInt(item.id, 10) === parseInt(checkFor, 10))
      }
      setSelectedPaymentTerm(selectedPaymentTerm)
      calculatesDueDate(selectedPaymentTerm, form?.dateOfReceipt)
    }
    onChange('paymentTerm', paymentTerm)
  }, [company?.paymentTerms, form?.dateOfReceipt, paymentTermsOfTransactions])

  const paymentTerms = useCallback(
    () => {
      const terms = company && company.paymentTerms ? company.paymentTerms.map(item => ({
        value: 'company_' + item.id,
        label: 'Company ' + item.type?.name + ' / ' + item.days + ' D'
      })) : []
      for (let i = 0; i < paymentTermsOfTransactions().length; i++) {
        terms.push({
          value: 'transaction_' + paymentTermsOfTransactions()[i].id,
          label: 'Transaction ' + paymentTermsOfTransactions()[i].type + ' / ' + paymentTermsOfTransactions()[i].days + ' D'
        })
      }
      return terms
    },
    [company, paymentTermsOfTransactions, lines]
  )

  useEffect(() => {
    if (form.paymentTerm && typeof form.paymentTerm === 'string') {
      onPaymentTermChange('paymentTerm', form.paymentTerm)
    }
  }, [form?.paymentTerm, company?.paymentTerms, form.dateOfReceipt, lines])

  return {
    allPaymentTerms: paymentTerms(),
    selectedPaymentTerm,
    onPaymentTermChange,
    paymentTermProblem: problem()
  }
}

export default useMultipleCostInvoicePaymentTerm
